export function formatDate(iso: string, language: string) {
    const pastDate = new Date(iso); 
    const now = new Date();
  
    //@ts-ignore
    const diffInMs = now - pastDate;
    
    const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
  
    let minutesWord;
    const lastDigit = diffInMinutes % 10;
    const lastTwoDigits = diffInMinutes % 100;
  
    if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
      minutesWord = language === 'en' ? 'minutes' : 'минут';
    } else if (lastDigit === 1) {
      minutesWord = language === 'en' ? 'minute' : 'минуту';
    } else if (lastDigit >= 2 && lastDigit <= 4) {
      minutesWord = language === 'en' ? 'minutes' : 'минуты';
    } else if (lastDigit === 0 && lastTwoDigits === 0) {
      minutesWord = language === 'en' ? 'less than a minute' : 'менее минуты';
    } else {
      minutesWord = language === 'en' ? 'minutes' : 'минут';
    }

    if (diffInMinutes >= 60) {
      const day = String(pastDate.getDate()).padStart(2, '0');
      const month = String(pastDate.getMonth() + 1).padStart(2, '0');
      const year = pastDate.getFullYear();
      const hours = String(pastDate.getHours()).padStart(2, '0');
      const minutes = String(pastDate.getMinutes()).padStart(2, '0');
      return `${day}.${month}.${year}  ${hours}:${minutes}`;
    }
  
    return `${diffInMinutes > 0 ? diffInMinutes : ''} ${minutesWord} ${language === 'en' ? 'ago' : 'назад'}`;
  }
export function formatDate(iso: string, language: string) {
    const pastDate = new Date(iso); 
    const now = new Date();
  
    //@ts-ignore
    const diffInMs = now - pastDate;
    
    const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
  
    let minutesWord;
    const lastDigit = diffInMinutes % 10;
    const lastTwoDigits = diffInMinutes % 100;
  
    if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
      minutesWord = language === 'en' ? 'minutes' : 'минут';
    } else if (lastDigit === 1) {
      minutesWord = language === 'en' ? 'minute' : 'минуту';
    } else if (lastDigit >= 2 && lastDigit <= 4) {
      minutesWord = language === 'en' ? 'minutes' : 'минуты';
    } else if (lastDigit === 0 && lastTwoDigits === 0) {
      minutesWord = language === 'en' ? 'less than a minute' : 'менее минуты';
    } else {
      minutesWord = language === 'en' ? 'minutes' : 'минут';
    }

    if (diffInMinutes >= 60) {
      const day = String(pastDate.getDate()).padStart(2, '0');
      const month = String(pastDate.getMonth() + 1).padStart(2, '0');
      const year = pastDate.getFullYear();
      const hours = String(pastDate.getHours()).padStart(2, '0');
      const minutes = String(pastDate.getMinutes()).padStart(2, '0');
      return `${day}.${month}.${year}  ${hours}:${minutes}`;
    }
  
    return `${diffInMinutes > 0 ? diffInMinutes : ''} ${minutesWord} ${language === 'en' ? 'ago' : 'назад'}`;
  }
